import {useMemo} from 'react';
import {bindActionCreators} from '@reduxjs/toolkit';
import {useAppDispatch} from './reduxHooks';
import {actions as positionActions} from '../ducks/position.duck';
import {actions as mainActions} from '../ducks/main.duck';
import {actions as userActions} from '../ducks/user.duck';

const rootActions = {
    ...positionActions,
    ...mainActions,
    ...userActions,
};
export const useActions = () => {
    const dispatch = useAppDispatch();
    return useMemo(() => bindActionCreators(rootActions, dispatch), [dispatch]);
};